// extracted by mini-css-extract-plugin
export var pageTitleBgNews = "pageTitleNews-module--pageTitleBgNews--CelZu";
export var pageTitleContainer = "pageTitleNews-module--pageTitleContainer--ce-Lh";
export var pageTitleNews = "pageTitleNews-module--page-TitleNews--lqo7B";